import { cn } from '@/lib/utils'
import type { BreakdownTone, SegmentedBreakdownSegment } from './types'

export interface SegmentedBreakdownProps {
  segments: SegmentedBreakdownSegment[]
  label?: string
  className?: string
}

const toneClasses: Record<BreakdownTone, string> = {
  critical: 'border-destructive/60 bg-destructive/10 text-destructive',
  high: 'border-orange-500/60 bg-orange-500/10 text-orange-700 dark:text-orange-300',
  medium: 'border-amber-500/60 bg-amber-500/10 text-amber-700 dark:text-amber-300',
  low: 'border-emerald-500/60 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
  neutral: 'border-border bg-muted/40 text-muted-foreground',
}

const toneLabels: Record<BreakdownTone, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  neutral: 'Neutral',
}

export function SegmentedBreakdown({
  segments,
  label = 'Segmented breakdown',
  className,
}: SegmentedBreakdownProps) {
  return (
    <div className={cn('space-y-2', className)} aria-label={label}>
      {segments.map((segment) => {
        const tone = segment.tone ?? 'neutral'
        return (
          <div
            key={segment.label}
            className={cn(
              'rounded-lg border px-3 py-2',
              'flex items-center justify-between gap-3',
              toneClasses[tone],
            )}
          >
            <span className="min-w-0 text-sm font-medium">{segment.label}</span>
            <span className="text-right text-sm font-semibold">
              {segment.value.toLocaleString('en-GB')}{' '}
              <span className="text-xs font-medium">{toneLabels[tone]}</span>
            </span>
          </div>
        )
      })}
    </div>
  )
}
